module.exports = __webpack_public_path__ + "static/img/鼠标经过有投影.db0b3ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/鼠标经过有投影.png
// module id = yACn
// module chunks = 1